export const desktopChunkSize = 1000;
export const minChunkSize = 50;
export const mobileChunkSize = 250;
export const specialSymbol = "\u00A0";
export const symbolMapping = { "<": "lessthan", ">": "greaterthan" };
const utteranceProperties = ["lang", "voice", "volume", "rate", "pitch"];
const utteranceEvents = ["onstart", "onend", "onerror", "onpause", "onresume", "onmark", "onboundary"];
export const utterancePropertiesAndEvents = utteranceProperties.concat(utteranceEvents);
